<template>
  <th @click="handleClick" class="sortable-header">
    <slot></slot>
    <i v-if="isActive" :class="sortIcon"></i>
  </th>
</template>

<script>
export default {
  name: "SortableHeader",
  props: {
    // The key this header sorts by
    sortKey: {
      type: String,
      required: true,
    },
    // Current sort state object { key, order }
    sortState: {
      type: Object,
      required: true,
      validator: (val) => "key" in val && "order" in val,
    },
  },
  emits: ["sort"],
  computed: {
    isActive() {
      return this.sortState.key === this.sortKey;
    },
    sortIcon() {
      return this.sortState.order === "asc"
        ? "fas fa-sort-up ml-1"
        : "fas fa-sort-down ml-1";
    },
  },
  methods: {
    handleClick() {
      this.$emit("sort", this.sortKey);
    },
  },
};
</script>

<style lang="scss" scoped>
.sortable-header {
  cursor: pointer;
  user-select: none;

  &:hover {
    background-color: #f6f9fc;
  }
}
</style>
